const localeDecimals = {
  es_CL: 0,
  es_MX: 2,
  es_PE: 2,
  es_CO: 0,
  es_EC: 2,
  en_US: 2,
  es_CR: 2
}

export default localeDecimals
